import { TooltipData, TooltipPosition } from './CursorTooltip.types';

export const getTooltipMessage = (element: HTMLElement): TooltipData | null => {
  const title = element.getAttribute('data-tooltip-title');
  const content = element.getAttribute('data-tooltip-content');

  if (!title || !content) return null;

  return { title, content };
};

const constrainHorizontal = (
  x: number,
  width: number,
  padding: number,
): number => {
  if (x + width > window.innerWidth - padding) {
    return window.innerWidth - width - padding;
  }
  return x < padding ? padding : x;
};

const constrainVertical = (
  y: number,
  height: number,
  padding: number,
): number => {
  if (y + height > window.innerHeight - padding) {
    return window.innerHeight - height - padding;
  }
  return y < padding ? padding : y;
};

export const calculateTooltipPosition = (
  x: number,
  y: number,
  tooltipRef: React.RefObject<HTMLDivElement>,
  config: { maxWidth: number; offset: number; viewportPadding: number },
): TooltipPosition => {
  const { maxWidth, offset, viewportPadding } = config;
  let tooltipHeight = 100;

  if (tooltipRef.current?.offsetHeight) {
    tooltipHeight = tooltipRef.current.offsetHeight;
  }

  const tooltipX = constrainHorizontal(x + offset, maxWidth, viewportPadding);
  const tooltipY = constrainVertical(
    y + offset,
    tooltipHeight,
    viewportPadding,
  );

  return { x: tooltipX, y: tooltipY, width: maxWidth };
};

export const isElementVisible = (rect: DOMRect): boolean => {
  return (
    rect.top < window.innerHeight &&
    rect.bottom > 0 &&
    rect.left < window.innerWidth &&
    rect.right > 0
  );
};

const isPositionInRect = (x: number, y: number, rect: DOMRect): boolean => {
  return x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;
};

export const findTooltipElementAtPosition = (
  x: number,
  y: number,
  elements: HTMLElement[],
): HTMLElement | null => {
  for (const element of elements) {
    const rect = element.getBoundingClientRect();
    if (isPositionInRect(x, y, rect) && isElementVisible(rect)) {
      return element;
    }
  }
  return null;
};

export const isInsideContainer = (
  x: number,
  y: number,
  containerRef: React.RefObject<HTMLDivElement>,
): boolean => {
  if (!containerRef.current) return false;
  const rect = containerRef.current.getBoundingClientRect();
  return isPositionInRect(x, y, rect);
};

export const isValidPosition = (position: TooltipPosition | null): boolean => {
  return !!(
    position &&
    Number.isFinite(position.x) &&
    Number.isFinite(position.y) &&
    position.x >= 0 &&
    position.y >= 0
  );
};
